const grantPermission = requestedRole => {
  const baseRole = JSON.parse(localStorage.getItem('user'));
  var isValid = false;

  if (baseRole) {
    isValid = requestedRole === baseRole.role.roleName;
    return isValid;
  }
};

/*
  Код для теста

  const grantPermission = (requestedAuthorities, currentUserAuthorities) => {
    return requestedAuthorities.every(requestedAuthority => currentUserAuthorities.includes(requestedAuthority));
  };

  const requestedAuthorities = [1, 2, 3];
  const currentUserAuthorities = [1, 2, 4, 5]

  console.log(grantPermission(requestedAuthorities, currentUserAuthorities))
*/

export default grantPermission;